<template>
  <PaymentSafetyNote />
  <AppRow class="mb-7">
    <div>
      <BasketSummary :form />
      <CouponFields v-model="form.discount" />
    </div>
    <LightBox>
      <PaymentProcessorRadio v-model="processor" :no-mobile="form.urgency != 'none'" />
    </LightBox>
  </AppRow>
  <nuxt-error-boundary ref="errorBoundary">
    <keep-alive :key="total">
      <Suspense>
        <CreditCardFields v-if="processor == 'stripe'" :form />
        <PayPal v-else-if="processor == 'paypal'" :form />
        <Tbank v-else-if="processor == 'tbank'" :form />
        <MobilePaymentFields v-else-if="processor == 'bit' || processor == 'paybox'" :processor :form />
        <PayByBillRu v-else-if="locale == 'ru' && processor == 'bill'" :form />

        <template #fallback>
          <LoadingSpinner />
        </template>
      </Suspense>
    </keep-alive>

    <template #error="{ clearError }">
      <AppAlert type="error">
        {{ $tt('payment_processor_error_alert') }}
        <AppBtn prepend-icon="mdi:refresh" size="small" class="ms-2" @click="clearError">
          {{ $tt('retry') }}
        </AppBtn>
      </AppAlert>
    </template>
  </nuxt-error-boundary>
  <PaymentCtaNote :processor :total />
</template>

<script setup lang="ts">
import type { PaymentProcessor, VisaForm } from '~/types';

const form = defineModel<VisaForm>({ required: true });

const { paymentProcessors, locale } = useBranch();
const [defaultProcessor] = paymentProcessors;
const processor = ref<PaymentProcessor>(defaultProcessor);
const { total } = useFormPrice(form);
const errorBoundary = useTemplateRef('errorBoundary');

watch(processor, () => {
  errorBoundary.value?.clearError();
});
</script>